/* import __COLOCATED_TEMPLATE__ from './content-paused-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();